import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as legalEntitiesState from '../reducers';
import * as legalEntitiesReducer from '../reducers/get-businesses.reducer';

export const selectLegalEntitiesBusinesses = createSelector(
  legalEntitiesState.getLegalEntitiesBusinessesState,
  legalEntitiesReducer.getLegalEntitiesBusinesses
);
